import React from 'react';

const SideBarLogoutLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16634 18.3334C3.94533 18.3334 3.73337 18.2456 3.57709 18.0893C3.42081 17.9331 3.33301 17.7211 3.33301 17.5001V2.50008C3.33301 2.27907 3.42081 2.06711 3.57709 1.91083C3.73337 1.75455 3.94533 1.66675 4.16634 1.66675H15.833C16.054 1.66675 16.266 1.75455 16.4223 1.91083C16.5785 2.06711 16.6663 2.27907 16.6663 2.50008V5.00008H14.9997V3.33341H4.99967V16.6667H14.9997V15.0001H16.6663V17.5001C16.6663 17.7211 16.5785 17.9331 16.4223 18.0893C16.266 18.2456 16.054 18.3334 15.833 18.3334H4.16634ZM14.9997 13.3334V10.8334H9.16634V9.16675H14.9997V6.66675L19.1663 10.0001L14.9997 13.3334Z"
        fill="#6D758E"
      />
    </svg>
  );
};

export default SideBarLogoutLogo;